export const environment = {
    production: false,
    apiHost: 'https://dev-api.ai-arcs.com',
    basePath: '/api/v1',
    primeuiLicenseKey:
        'eyJpZCI6IjZiYWRmMWQ5LTU5MDMtNDRmOC05ODQxLTM1MGY4OGY0MzA4ZCIsInByb2R1Y3QiOiJwcmltZXVpIiwidGllciI6ImNvbW11bml0eSIsInR5cGUiOiJkZXYiLCJpYXQiOjE3ODk5ODk2MTIsImV4cCI6MTgyMTUyNTYxMn0.E7MQIWKkLkLcXOHwHWQeZPNCjetvZv8wbexDWqchy33gUPQQk-5G6lRsAFdqiBnoDuedMZ1UuLYqkzpoXj-iBg',
};
